export default "__VITE_ASSET__CfAHDy1G__"